import React, { Fragment } from 'react';

const Picture = ({ src, webpSrc, mobileSrc, alt, className, desktop, mobile, noWebp }) => {
    const extension = src.split('.').pop();
    const webpSource = webpSrc || src.replace(`.${extension}`, '.webp');
    const desktopClass = desktop ? 'desktop-only' : '';
    const mobileClass = mobile ? 'mobile-only' : '';

    return (
        <picture>
            {mobileSrc && (
                <Fragment>
                    {!noWebp && (
                        <source
                            srcSet={`${webpSource}, ${mobileSrc.replace(`.${extension}`, '.webp')} 2x`}
                            media="(max-width: 990px)"
                            type="image/webp"
                        />
                    )}
                    <source
                        srcSet={`${src}, ${mobileSrc} 2x`}
                        media="(max-width: 990px)"
                        type={`image/${extension}`}
                    />
                </Fragment>
            )}
            {!noWebp && (
                <source srcSet={`${webpSource}`} type="image/webp" />
            )}
            <img
                className={`${className} ${desktopClass} ${mobileClass}`}
                src={`${src}`}
                alt={`${alt}`}
            />
        </picture>
    );
};

export default Picture;



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/Picture.jsx